import React from 'react';
import Home from './Components/Home.js';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Home />
  );
}

export default App;
